import * as React from 'react';
import { Sidebar as SidebarStyled } from '@app/src/components/Sidebar';
import { getConfigsEnabled } from '@app/src/utils/validations';
import { Items } from './types/Items';
import { VIEW } from './constants';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { serviceLogout } from '@app/src/views/Logout/logoutService';

interface Props {
  history: any;
  resetViewCipGeneration: Function;
  resetViewCipReport: Function;
  logout: Function;
  enabledButtons?: boolean;
}

export const Sidebar: React.FC<Props> = ({
  history,
  resetViewCipGeneration,
  resetViewCipReport,
  logout,
  enabledButtons = true
}) => {

  const enabled: boolean = enabledButtons;
  const isAdmin: boolean = decodeAccessToken('isAdmin');
  const serviceName: string = decodeAccessToken('service');
  const currentView: string = history.location.pathname;

  const getViewCipGeneration = () => {
    history.push(VIEW.CIP_GENERATION);
    resetViewCipReport();
  };

  const getViewCipReport = () => {
    history.push(VIEW.CIP_REPORT);
    resetViewCipGeneration();
  };

  const getViewUsers = () => {
    history.push(VIEW.USERS);
    resetViewCipGeneration();
    resetViewCipReport();
  };

  const isSelectedView = (currentView: string, view: string): boolean => {
    return currentView === view;
  };

  const itemsTop: Items[] = [
    {
      icon: {
        name: 'plus'
      },
      tooltip: 'Generador CIP',
      dataTest: 'navCip',
      onClick: getViewCipGeneration,
      selected: isSelectedView(currentView, VIEW.CIP_GENERATION),
      enabled
    },
    {
      icon: {
        name: 'book-open'
      },
      tooltip: 'Reportes',
      dataTest: 'navReportes',
      onClick: getViewCipReport,
      selected: isSelectedView(currentView, VIEW.CIP_REPORT),
      enabled
    }
  ];

  const itemsBottom: Items[] = [
    isAdmin && {
      icon: {
        name: 'user'
      },
      tooltip: 'Usuarios',
      dataTest: 'navUsuarios',
      onClick: getViewUsers,
      selected: isSelectedView(currentView, VIEW.USERS) || isSelectedView(currentView, VIEW.CREATE_USER),
      enabled
    },
    {
      icon: { name: 'log-out' },
      tooltip: 'Salir',
      dataTest: 'navSalir',
      onClick: async () => {
        await serviceLogout.logout();
        logout(history);
      },
      enabled: true
    }
  ];

  React.useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'idUser' && !event.newValue) {
        logout(history)
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return(
    <SidebarStyled
      title={`CallCenter / ${serviceName}`}
      itemsTop={getConfigsEnabled(itemsTop)}
      itemsBottom={getConfigsEnabled(itemsBottom)}
      fixed
    />
  );
};
